(() => {
  'use strict';

  if (window.__amelieNuevaGranadaShippingLoaded) return;
  window.__amelieNuevaGranadaShippingLoaded = true;

  const TARGET_PROVINCE = 'MAG';
  const TARGET_CITY = 'nueva granada';
  const STANDARD_COD_PRICE = 2000000;
  const NUEVA_GRANADA_COD_PRICE = 3000000;
  const PROVINCE_SELECTOR = '#_rsi-field-province_country_field';
  const CITY_SELECTOR = '#_rsi-field-city';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('es-CO');
  }

  function selectedText(select) {
    if (!select) return '';
    return select.options?.[select.selectedIndex]?.textContent || select.value || '';
  }

  function nationalCashOnDeliveryRate(rsi) {
    return rsi.s.shippingRates.items_array.find(
      (rate) =>
        rate?.type === 'custom' &&
        normalize(rate.title) === 'envio contraentrega nacional',
    );
  }

  function renderVisibleRate(rate, targetPrice) {
    const row = document.querySelector(
      `._rsi-modal-shipping-rates-item[data-priority="${rate.priority}"]`,
    );
    if (!row) return;

    const price = row.querySelector('._rsi-modal-checkout-line-price');
    if (price) {
      price.textContent = `$${Math.round(targetPrice / 100).toLocaleString('es-CO')}`;
    }
  }

  function syncRate() {
    const rsi = window._rsi;
    const rates = rsi?.s?.shippingRates?.items_array;
    if (!Array.isArray(rates)) return false;

    const province = document.querySelector(PROVINCE_SELECTOR)?.value || '';
    const citySelect = document.querySelector(CITY_SELECTOR);
    const isNuevaGranada =
      province === TARGET_PROVINCE && normalize(selectedText(citySelect)) === TARGET_CITY;
    const targetPrice = isNuevaGranada
      ? NUEVA_GRANADA_COD_PRICE
      : STANDARD_COD_PRICE;
    const rate = nationalCashOnDeliveryRate(rsi);
    if (!rate) return false;

    const currentRate = rsi.shippingRates?.currentRate;
    const isCurrentRate =
      currentRate &&
      (currentRate === rate || Number(currentRate.priority) === Number(rate.priority));
    const priceChanged = Number(rate.price) !== targetPrice;

    rate.price = targetPrice;
    if (isCurrentRate) currentRate.price = targetPrice;

    if (isCurrentRate && (priceChanged || document.querySelector(CITY_SELECTOR))) {
      rsi.shippingRates.onRateChange?.(rate.priority);
    }
    renderVisibleRate(rate, targetPrice);
    return true;
  }

  function queueSync() {
    window.setTimeout(syncRate, 0);
    window.setTimeout(syncRate, 80);
    window.setTimeout(syncRate, 300);
    window.setTimeout(syncRate, 700);
    window.setTimeout(syncRate, 1500);
  }

  document.addEventListener(
    'change',
    (event) => {
      if (event.target?.matches?.(`${PROVINCE_SELECTOR}, ${CITY_SELECTOR}`)) queueSync();
    },
    true,
  );

  const observer = new MutationObserver((mutations) => {
    if (
      mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.(CITY_SELECTOR) || node.querySelector?.(CITY_SELECTOR)),
        ),
      )
    ) {
      queueSync();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  function boot() {
    attempts += 1;
    if (syncRate() || attempts >= 120) return;
    window.setTimeout(boot, 250);
  }
  boot();
})();
